import styled from 'styled-components';

export const AdditionalContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  a {
    text-decoration: none;
    color: #fff;
  }
`;

export const AddButtonWrapper = styled.div`
  button {
    height: 50px;
  }
`;

export const FilterWrapper = styled.div`
  margin-right: auto;
`;

export const SearchWrapper = styled.div`
  margin-right: 20px;
  width: 214px;
`;

export const ThInner = styled.div`
  display: flex;
  position: relative;
  padding: 16px;
`;

export const TableWrapper = styled.table<any>`
  border: 1px solid #c0c2c6;
  border-width: 0 1px 1px;
  color: #2d3540;
  background-color: #fff;
  font-size: 14px;
  width: 100%;
  margin: 20px 0 36px 0;

  thead {
    position: relative;
    background-color: #f4f0ef;

    th {
      position: relative;
      text-align: left;
      border-top: 1px solid #c0c2c6;

      &:not(:first-child) {
        border-left: 1px solid #c0c2c6;
      }

      button {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        font-weight: 600;
        text-align: left;
        width: 100%;
        line-height: inherit;
      }
    }
  }

  tbody {
    td {
      max-width: 260px;
      padding: 12px 16px;
      word-break: break-word;
    }

    tr {
      width: 100%;

      &:hover {
        background-color: #670d2d !important;
        color: #fff;

        a {
          color: #fff;
        }
      }

      &:nth-child(even) {
        background-color: #faf9f8;
      }

      button {
        cursor: pointer;
        font-weight: 600;
        text-decoration: underline;
        background-color: transparent;
      }

      &:not(:first-child) {
        td {
          border-top: 1px solid #c0c2c6;
        }
      }
    }

    a {
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      color: #f4534a;
      background-color: transparent;
      text-decoration: underline;
    }
  }
`;

export const SortIcon = styled.span`
  font-size: 22px;
  margin-left: 12px;
  margin-right: -6px;
  color: #2d3540;
`;

export const DisplayInfo = styled.tr`
  p {
    color: #2d3540;
    margin-bottom: 12px;
  }
`;
